<template>
  <DashboardContentBox
    :title="title"
    :subTitle="subTitle"
    :link="link"
    :linkName="linkName"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    :embedded="embedded"
    :scrollable="scrollable">
      <template v-slot:title>
        <slot name="title" />
      </template>
      <template v-slot:subtitle>
        <slot name="subtitle" />
      </template>

      <LoadingPanel v-if="loading" :loading="loading" />
      <slot v-if="!loading" />
  </DashboardContentBox>
</template>

<script>
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'

export default {
  name: 'AnalyticsWidget',
  components: {
    DashboardContentBox
  },
  props: {
    title: String,
    subTitle: String,
    link: String,
    linkName: String,
    loading: Boolean,
    gridWidth: Number,
    gridHeight: Number,
    embedded: Boolean,
    scrollable: Boolean
  }
  
}
</script>